import styled from "@emotion/styled";
import React from "react";
import { Link, Navigate, Outlet, RouteProps, useParams } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useStores } from "@stores";
import { MarketPageVMProvider, useMarketPageVM } from "./MarketPageVm";
import Layout from "@components/Layout";
import Text from "@components/Text";
import SizedBox from "@components/SizedBox";
import { ReactComponent as ArrowBackIcon } from "@src/assets/icons/backArrow.svg";
import { Row } from "@src/components/Flex";
import { MARKETS, POOLS, ROUTES } from "@src/constants";
import MarketInfo from "@screens/MarketPage/MarketInfo";
import AccountCard from "@screens/MarketPage/AccountCard";
import AccountSupplyAndBorrow from "@screens/MarketPage/AccountSupplyAndBorrow";
import FAQ from "@screens/MarketPage/FAQ";
import AssetsTable from "@screens/MarketPage/AssetsTable";

interface IProps {}

const Root = styled.div<{ apySort?: boolean; liquiditySort?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 16px;
  width: 100%;
  min-height: 100%;
  max-width: calc(1328px + 32px);
  margin-bottom: 72px;
  margin-top: 40px;
  text-align: left;
  
`;
const MarketPageImpl: React.FC<IProps> = observer(() => {
  const vm = useMarketPageVM();
  // const { accountStore, lendStore } = useStores();
  const market = MARKETS.find((m) => m.address === vm.marketId);
  if (!market) return <Navigate to={ROUTES.ROOT} />;
  return (
    <Layout>
      <Root apySort={vm.sortApy} liquiditySort={vm.sortLiquidity}>
        <Link to={ROUTES.ROOT}>
          <Row alignItems="center">
            <ArrowBackIcon />
            <Text weight={500} type="blue500">
              Back to Dashboard
            </Text>
          </Row>
        </Link>
        <SizedBox height={16} />
        <MarketInfo market={market} />
        <AccountCard market={market} />
        <AccountSupplyAndBorrow />
        <AssetsTable />
        <SizedBox height={40} />
        <FAQ />
        <Outlet/>
      </Root>
    </Layout>
  );
});

const MarketPage: React.FC<IProps & RouteProps> = () => {
  const params = useParams<{ marketId: string }>();
  if (params.marketId && !POOLS.some((p) => p.address === params.marketId)) {
    return <Navigate to={ROUTES.ROOT} />;
  }
  return (
    <MarketPageVMProvider marketId={params.marketId}>
      <MarketPageImpl />
    </MarketPageVMProvider>
  );
};

export default observer(MarketPage);
